import _ from "lodash";


import * as downloadAttachment from '@/api/crm/email/downloadAttachment';
import * as getConversations from '@/api/crm/email/getConversations';
import * as negotiatePubSub from '@/api/crm/email/negotiatePubSub.js';
import * as sendMessage from '@/api/crm/email/sendMessage.js';
import * as getEmailSyncList from '@/api/crm/email/emailSyncList/getEmailSyncList.js';
import * as addSyncVenue from '@/api/crm/email/emailSyncList/addSyncVenue.js';
import * as removeSyncVenue from '@/api/crm/email/emailSyncList/removeSyncVenue.js';
import * as addSyncVenueAlias from '@/api/crm/email/emailSyncList/addSyncVenueAlias.js';
import * as removeSyncVenueAlias from '@/api/crm/email/emailSyncList/removeSyncVenueAlias.js';
import * as changeAssignee from '@/api/crm/email/changeAssignee.js';
import * as changeStatus from '@/api/crm/email/changeStatus.js';
import * as changeTopic from '@/api/crm/email/changeTopic.js';
import * as attachGuest from '@/api/crm/email/attachGuest.js';
import * as detachGuest from '@/api/crm/email/detachGuest.js';

// Email signature
import * as createEmailSignature from '@/api/crm/email/emailSignature/createEmailSignature.js';
import * as updateEmailSignature from '@/api/crm/email/emailSignature/updateEmailSignature.js';
import * as getEmailSignature from '@/api/crm/email/emailSignature/getEmailSignature.js';


export default {
    namespaced: true,
    state: {
        emailSignature: null,
        emailSyncList: [],
        pubSubUrl: "",
        awaitingConfirmation: false,
        activeConversationId: "",
        labels: ["private"],
        meta: {
            unreadMails: {
                folder: { inbox: [], spam: [] },
                label: { private: [] }
            },
            draftMails: []
        },
        latestMessageNum: 0,
        // mailTags: [
        //     {
        //         text: 'Bugs',
        //         value: 'personal',
        //         color: 'success'
        //     },
        //     {
        //         text: 'Booking',
        //         value: 'company',
        //         color: 'primary'
        //     },
        //     {
        //         text: 'Website',
        //         value: 'important',
        //         color: 'warning'
        //     },
        //     {
        //         text: 'Other',
        //         value: 'private',
        //         color: 'danger'
        //     }
        // ],
        conversations: [],

    },
    mutations: {
        setActiveConversation(state, id) {
            state.activeConversationId = id;
        },
        gotEmailSignature(state, payload) {
            state.emailSignature = payload;
        },
        gotConversations(state, payload) {
            payload.map(e => {
                return {
                    ...e,
                    mailFolder: "inbox",
                    labels: ["private"], // these are not implemented in API yet...
                }
            });
            state.conversations = payload;

        },
        gotEmailSyncList(state, payload) {
            state.emailSyncList = payload;
        },

        addMessage(state, { convId, message }) {
            if (!state.conversations.some(e => e.id === convId)) return;
            state.conversations.find(e => e.id === convId).messages.push(message);
            if (!message.isSystemMessage) state.latestMessageNum++;
        },
        addConversation(state, conversation) {
            state.conversations.push(conversation);
            state.latestMessageNum++;
        },
        awaitingConfirmation(state, newState) {
            state.awaitingConfirmation = newState;
        },
        gotPubSubUrl(state, url) {
            state.pubSubUrl = url;
        },

        updateConversationProperty(state, { convId, property, value }) {
            state.conversations.find(e => e.id == convId)[property] = value;
            console.log("After change", state.conversations);
        },
    },
    actions: {
        async getAll({ commit, getters }, force = true) {
            if (!force && getters.conversations.length > 0) return;
            const result = await getConversations.get();
            if (result) commit("gotConversations", result);
        },

        async getSyncItems({ commit, getters }, force = true) {
            if (!force && getters.emailSyncList.length > 0) return;
            const result = await getEmailSyncList.get();
            if (result) commit("gotEmailSyncList", result);
        },

        async addSyncVenue({ dispatch }, dto) {
            await addSyncVenue.post(dto);
            await dispatch("getSyncItems", true)
        },

        async removeSyncVenue({ dispatch }, dto) {
            await removeSyncVenue.del(dto);
            await dispatch("getSyncItems", true)
        },

        async addSyncVenueAlias({ dispatch }, dto) {
            await addSyncVenueAlias.post(dto);
            await dispatch("getSyncItems", true)
        },

        async removeSyncVenueAlias({ dispatch }, dto) {
            await removeSyncVenueAlias.del(dto);
            await dispatch("getSyncItems", true)
        },

        async sendMessage({ dispatch, commit }, dto) {
            commit("awaitingConfirmation", true)
            await sendMessage.post(dto);
        },

        async setStatus({ dispatch, commit }, dto) {
            await changeStatus.post(dto);
        },

        async setAssignee({ dispatch, commit }, dto) {
            await changeAssignee.post(dto);
        },

        async addTopic({ dispatch, commit }, dto) {
            await changeTopic.post({ ...dto, remove: false });
        },

        async removeTopic({ dispatch, commit }, dto) {
            await changeTopic.post({ ...dto, remove: true });
        },

        async attachGuest({ dispatch, commit }, dto) {
            await attachGuest.post(dto);
        },

        async detachGuest({ dispatch, commit }, dto) {
            await detachGuest.post(dto);
        },

        async negotiatePubSub({ commit }) {
            const result = await negotiatePubSub.get();
            commit("gotPubSubUrl", result)
        },

        async downloadFileAttachment({ commit }, { venueMail, messageId, fileName, mimeType }) {
            var result = await downloadAttachment.post(venueMail, messageId, fileName)
            var file = new Blob([result], { type: mimeType });

            file.name = fileName
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        },


        handleSocketMessage({ commit }, dto) {
            console.log("Handling socket message", dto);
            switch (dto.pushType) {
                case "newMessage":
                    commit("addMessage", { convId: dto.threadId, message: dto.message });
                    commit("awaitingConfirmation", false)
                    break;
                case "newConversation":
                    commit("addConversation", dto.conversation);
                    commit("awaitingConfirmation", false)
                    break;
                case "changeAssignee":
                    commit("updateConversationProperty", { convId: dto.psid, property: "assignee", value: dto.message });
                    commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
                    break;
                case "changeStatus":
                    commit("updateConversationProperty", { convId: dto.psid, property: "status", value: dto.message });
                    commit("updateConversationProperty", { convId: dto.psid, property: "isOpen", value: dto.message == "OPEN" });
                    commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
                    break;
                case "changeTopics":
                    commit("updateConversationProperty", { convId: dto.psid, property: "topics", value: dto.message });
                    break;
                case "changeGuest":
                    commit("updateConversationProperty", { convId: dto.psid, property: "guestId", value: dto.message });
                    commit("addMessage", { convId: dto.psid, message: dto.systemMessage });
                    break;
            }
        },

        // Email signatures
        async getEmailSignature({ commit }) {
            const result = await getEmailSignature.get();
            commit("gotEmailSignature", result)
        },
        async createEmailSignature({ dispatch }) {
            await createEmailSignature.post();
            await dispatch("getEmailSignature")
        },
        async updateEmailSignature({ dispatch }, dto) {
            await updateEmailSignature.put(dto);
            await dispatch("getEmailSignature")
        },

    },
    getters: {
        conversation: state => (id) => state.conversations.find(e => e.id === id),
        conversationLastMessage: (state, getters) => (id) => [...getters.conversation(id).messages].filter(e => !e.isSystemMessage).pop(), // Non system message
        conversationIsOpen: (state, getters) => (id) => getters.conversation(id).isOpen,

        conversations: state => state.conversations,

        activeConversation: state => state.conversations.find(e => e.id === state.activeConversationId),
        activeConversationId: state => state.activeConversationId,

        awaitingConfirmation: state => state.awaitingConfirmation,

        pubSubUrl: state => state.pubSubUrl,

        meta: state => state.meta,
        labels: state => state.labels,
        // mailTags: state => state.mailTags,

        emailSyncList: state => state.emailSyncList,
        emailSyncItem: state => (id) => state.emailSyncList.find(e => e.id === id),
        emailSignature: state => state.emailSignature,
        hasEmailSignature: state => state.emailSignature !== null,

        latestMessageNum: state => state.latestMessageNum,
    }
};
